"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuPropType = exports.LocationPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));
/* eslint-disable react/forbid-prop-types */


var LocationPropType = _propTypes["default"].shape({
  city: _propTypes["default"].string,
  state: _propTypes["default"].string,
  street: _propTypes["default"].string,
  email: _propTypes["default"].string,
  phoneNumber: _propTypes["default"].string,
  locationName: _propTypes["default"].string
});

exports.LocationPropType = LocationPropType;

var MenuPropType = _propTypes["default"].shape({
  categories: _propTypes["default"].array,
  items: _propTypes["default"].array,
  modifierSets: _propTypes["default"].array,
  modifiers: _propTypes["default"].array,
  schedules: _propTypes["default"].array
});

exports.MenuPropType = MenuPropType;